module.exports = __webpack_public_path__ + "static/img/13.50189d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/13.png
// module id = Um/J
// module chunks = 0